import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
interface ParallaxBackgroundProps {
  imageUrl: string;
  children?: React.ReactNode;
  className?: string;
  overlayOpacity?: number;
  imageAlt?: string;
}
export function ParallaxBackground({
  imageUrl,
  children,
  className = '',
  overlayOpacity = 0.6,
  imageAlt = ''
}: ParallaxBackgroundProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  // Move the image slightly slower than the scroll for a subtle parallax
  const y = useTransform(scrollYProgress, [0, 1], ['-12%', '12%']);
  return (
    // NOTE: callers pass their own position class (e.g. "absolute inset-0").
    // We must NOT also hardcode `relative` here — two competing position
    // utilities collide and the container collapses, hiding the image.
    <div ref={ref} className={`overflow-hidden ${className}`} data-id="element-132">
      {/* Parallax image layer — rendered as a real <img> for reliable painting */}
      <motion.img src={imageUrl} alt={imageAlt} aria-hidden={imageAlt ? undefined : true} style={{
        y,
        scale: 1.15
      }} className="absolute inset-0 z-0 w-full h-full object-cover max-w-none" data-id="element-133" />

      {/* Dark overlay for legibility */}
      <div className="absolute inset-0 z-[1] bg-charcoal pointer-events-none" style={{
        opacity: overlayOpacity
      }} data-id="element-134" />

      <div className="relative z-10 w-full h-full" data-id="element-135">{children}</div>
    </div>
  );
}